<template>
  <q-card class="border-card q-ma-lg">
    <q-card-section class="l-text-title text-weight-bolder q-pb-none">
      Inbound
    </q-card-section>
    <q-card-section class="row">
      <div class="col-8 flex">
        <q-select
          borderless
          dense
          v-model="data.selectedOps"
          :options="data.options"
          emit-value
          map-options
          class="kiri-radius q-px-sm"
          style="width: 25%; background-color: white; height: 40px"
        />
        <q-input
          dense
          borderless
          class="kanan-radius q-px-sm"
          v-model="data.cariProduk"
          placeholder="Cari Nama Produk"
          style="width: 40%; height: 40px"
        />
        <q-btn
          class="q-mx-md"
          dense
          square
          unelevated
          color="brand"
          icon="search"
          style="border-radius: 8%; width: 50px"
          @click="
            data.pagination.current = 1;
            loadThis(getListInbound);
          "
        />
      </div>
      <div class="col-4 text-right">
        <q-btn
          class="q-mx-md q-px-sm text-weight-bold"
          color="brand"
          no-caps
          outline
          label="Export"
        />
        <q-btn-dropdown
          class="text-weight-bold"
          @click="openDialog = true"
          no-caps
          split
          unelevated
          color="brand"
          label="Buat Inbound"
        >
          <q-list>
            <q-item clickable v-close-popup @click="onItemClick">
              <q-item-section>
                <q-item-label>XXX</q-item-label>
              </q-item-section>
            </q-item>

            <q-item clickable v-close-popup @click="onItemClick">
              <q-item-section>
                <q-item-label>YYY</q-item-label>
              </q-item-section>
            </q-item>

            <q-item clickable v-close-popup @click="onItemClick">
              <q-item-section>
                <q-item-label>ZZZ</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </div>
    </q-card-section>

    <!-- table context -->
    <q-card-section>
      <q-markup-table flat bordered>
        <thead class="bg-grey-2">
          <tr>
            <th class="text-left" style="width: 1%">
              <q-checkbox
                v-model="data.selectAll"
                id="select-all"
                @update:model-value="selectAll"
                :true-value="1"
                :false-value="0"
              />
            </th>
            <th class="text-left">No.Dokumen</th>
            <th class="text-center">Diterima</th>
            <th class="text-center">Staff</th>
            <th class="text-center">Status</th>
            <th class="text-center">Keterangan</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in data.rows" :key="idx">
            <td class="text-left">
              <q-checkbox
                v-model="item.checked"
                @update:model-value="selectItem()"
                :true-value="1"
                :false-value="0"
              />
            </td>
            <td class="text-left">{{ item.no_dokumen }}</td>
            <td class="text-center">
              {{ moment(item.received_at).format("DD/MM/YY HH:mm") }}
            </td>
            <td class="text-left">{{ item.staff_name }}</td>
            <td
              class="text-center"
              v-bind:style="[
                item.status == 'Selesai'
                  ? { color: '#137A2E' }
                  : { color: 'red' },
              ]"
            >
              {{ item.status }}
            </td>
            <td class="text-left" style="color: #3d3099">{{ item.remarks }}</td>
            <td class="text-center">
              <q-btn
                label="View Detail"
                flat
                no-caps
                color="accent"
                dense
                :to="`/inbound/Form-Inbound/${item.id_staff}/${item.id}`"
              />
            </td>
          </tr>
        </tbody>
      </q-markup-table>

      <!-- pagination -->
      <div class="q-pt-lg flex flex-center">
        <q-pagination
          v-model="data.pagination.current"
          :max="data.pagination.max"
          input
          @update:model-value="loadThis(getListInbound)"
        />
      </div>
    </q-card-section>

    <q-dialog v-model="openDialog">
      <q-card class="my-font">
        <q-card-section class="text-center">
          <div class="text-h6 text-bold">Staff Inbound</div>
          <div class="text-grey-8">
            Pilih staff inbound yang bertugas untuk melakukan ibound produk
          </div>
        </q-card-section>

        <q-card-section class="q-pt-none row items-center q-gutter-x-md">
          <div>Staff</div>
          <q-select
            outlined
            dense
            use-input
            map-options
            emit-value
            class="l-grow"
            v-model="data.selStaff"
            :options="data.filteredStaff"
            @filter="filterFn"
          />
        </q-card-section>

        <q-card-actions align="center">
          <q-btn
            outline
            no-caps
            dense
            label="Batalkan"
            color="brand"
            v-close-popup
          />
          <q-btn
            unelevated
            no-caps
            dense
            text-color="white"
            label="Konfirmasi"
            color="brand"
            :to="`/inbound/Form-Inbound/${data.selStaff}`"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-card>
</template>

<script>
// @ is an alias to /src
import useBasic from "@/composables/useBasic";

export default {
  name: "InBoundView",
  setup() {
    const { ref, reactive, onMounted, loadThis, $http, moment } = useBasic();

    //   const selected = ref([])
    //   const currentPage = ref(1)
    //   const rows = ref([
    //   {
    //     name: 'TRR21/014461',
    //     diterima: '13/06/23 15:00',
    //     staff: 'Robert Fox',
    //     status: 'Selesai',
    //     ket: 'Ladies Klensia',
    //     aksi: 'view',
    //     checked:false,
    //   },
    //   {
    //     name: 'TRR21/014462',
    //     diterima: '13/06/23 15:00',
    //     staff: 'Robert Fox',
    //     status: 'Belum Selesai',
    //     ket: 'Ladies Klensia',
    //     aksi: 'view',
    //     checked:false,
    //   },
    //   {
    //     name: 'TRR21/014463',
    //     diterima: '13/06/23 15:00',
    //     staff: 'Robert Fox',
    //     status: 'Selesai',
    //     ket: '',
    //     aksi: 'view',
    //     checked:false,
    //   },
    //   {
    //     name: 'TRR21/014464',
    //     diterima: '13/06/23 15:00',
    //     staff: 'Robert Fox',
    //     status: 'Selesai',
    //     ket: '',
    //     aksi: 'view',
    //     checked:false,
    //   },
    //   {
    //     name: 'TRR21/014465',
    //     diterima: '13/06/23 15:00',
    //     staff: 'Robert Fox',
    //     status: 'Selesai',
    //     ket: '',
    //     aksi: 'view',
    //     checked:false,
    //   },
    //   {
    //     name: 'TRR21/014466',
    //     diterima: '13/06/23 15:00',
    //     staff: 'Robert Fox',
    //     status: 'Selesai',
    //     ket: '',
    //     aksi: 'view',
    //     checked:false,
    //   },
    //   {
    //     name: 'TRR21/014467',
    //     diterima: '13/06/23 15:00',
    //     staff: 'Robert Fox',
    //     status: 'Selesai',
    //     ket: '',
    //     aksi: 'view',
    //     checked:false,
    //   },
    //   {
    //     name: 'TRR21/014468',
    //     diterima: '13/06/23 15:00',
    //     staff: 'Robert Fox',
    //     status: 'Selesai',
    //     ket: '',
    //     aksi: 'view',
    //     checked:false,
    //   },
    //   {
    //     name: 'TRR21/014469',
    //     diterima: '13/06/23 15:00',
    //     staff: 'Robert Fox',
    //     status: 'Selesai',
    //     ket: '',
    //     aksi: 'view',
    //     checked:false,
    //   },
    //   {
    //     name: 'TRR21/0144610',
    //     diterima: '13/06/23 15:00',
    //     staff: 'Robert Fox',
    //     status: 'Selesai',
    //     ket: '',
    //     aksi: 'view',
    //     checked:false,
    //   },
    //   {
    //     name: 'TRR21/0144611',
    //     diterima: '13/06/23 15:00',
    //     staff: 'Robert Fox',
    //     status: 'Selesai',
    //     ket: '',
    //     aksi: 'view',
    //     checked:false,
    //   },
    //   {
    //     name: 'TRR21/0144612',
    //     diterima: '13/06/23 15:00',
    //     staff: 'Robert Fox',
    //     status: 'Selesai',
    //     ket: '',
    //     aksi: 'view',
    //     checked:false,
    //   },
    //   {
    //     name: 'TRR21/0144613',
    //     diterima: '13/06/23 15:00',
    //     staff: 'Robert Fox',
    //     status: 'Selesai',
    //     ket: '',
    //     aksi: 'view',
    //     checked:false,
    //   }
    // ])
    //   const maxPage = Math.ceil(rows.value.length / 10)
    //   const selectAll = ref(false)
    // const cariProduk = ref('')
    // const options = ['No.Inbound', 'op1', 'op2', 'op3', 'op4']
    // const selectedOps = ref('No.Inbound')

    let data = reactive({
      rows: [],
      selected: [],
      selectAll: 0,
      cariProduk: "",
      options: [
        { label: "No.Inbound", value: "no_dokumen" },
        { label: "Nama Staff", value: "staff_name" },
      ],
      selectedOps: "no_dokumen",
      staff: "",
      pagination: {
        limit: 10,
        max: 1,
        current: 1,
      },
      optStaff: [],
      selStaff: null,
      filteredStaff: [],
    });

    const openDialog = ref(false);

    //######## FUNCTION #########
    function onItemClick() {
      // console.log('Clicked on an Item')
    }

    // function sliceData (data, page, rowsPerPage) {
    //   return data.slice((page - 1) * rowsPerPage, page * rowsPerPage);
    // }

    function selectItem() {
      for (let i = 0; i < data.rows.length; i++) {
        if (data.rows[i].checked) {
          data.selectAll = null;
          return;
        }
      }

      data.selectAll = false;
    }

    function selectAll(value) {
      console.log(value);
      data.rows.forEach((element) => {
        element.checked = value;
      });
    }

    let getListInbound = async () => {
      let resp = await $http.get(
        `/inbound/list?current=${data.pagination.current}&limit=${data.pagination.limit}&search=${data.cariProduk}&search_field=${data.selectedOps}`
      );
      // console.log(resp.data.rows);
      data.rows = resp.data.rows;
      data.pagination.max = Math.ceil(
        resp.data.max_rows / data.pagination.limit
      );
    };

    onMounted(async () => {
      await loadThis(prepareData);
    });

    let prepareData = async () => {
      await getListInbound();
      await getStaff();
    };

    let getStaff = async () => {
      let resp = await $http.get(`/setting/list-staff`);
      data.optStaff = resp.data;
    };

    let filterFn = (val, update, abort) => {
      update(() => {
        const needle = val.toLowerCase();
        data.filteredStaff = data.optStaff.filter(
          (v) => v.label.toLowerCase().indexOf(needle) > -1
        );
      });
    };

    return {
      data,
      // selectedOps,
      // options,
      // cariProduk,
      // selected,
      // rows,
      // currentPage,
      // maxPage,
      // selectAll,
      openDialog,
      moment,
      loadThis,

      onItemClick,
      // sliceData,
      selectItem,
      selectAll,
      getListInbound,
      filterFn,
    };
  },
};
</script>

<style>
.q-table thead th {
  font-weight: bold;
}
</style>
